
define('text!modules/reporting/campaigns/contextual/templates/chart.html',[],function () { return '<div class="contextual-canvas-container">\n  <canvas id="contextual-chart"></canvas>\n  {{>chartNoDataChart}}\n</div>\n';});

